export default function StylePlugin(editor) {
    editor.editing.view.change(writer=>{
        writer.setStyle('min-height', '300px', editor.editing.view.document.getRoot());
    });
}
